/**
 * Configuración compartida de modelos 3D por especie
 *
 * Este archivo centraliza el mapeo de especies a modelos 3D
 * para asegurar consistencia entre el mapa y el popup.
 *
 * scaleFactor: Multiplicador de escala base (1.0 = tamaño normal)
 *              Ajusta este valor si el modelo es muy grande o pequeño
 */

export const SPECIES_MODELS = {
  'Phoenix canariensis': {
    id: 'tree-Phoenix',
    url: '/models/palm_1_Tree.glb',
    scaleFactor: 0.4, // Ajustar si es necesario
  },
  'Morus alba': {
    id: 'tree-morus',
    url: '/models/morus_alba.glb',
    scaleFactor: 0.8, // Ajustar si es necesario
  },
  'Araucaria heterophylla': {
    id: 'tree-araucaria',
    url: '/models/araucaria.glb',
    scaleFactor: 0.5,
  },
  'Handroanthus chrysanthus': {
    id: 'tree-handroanthus',
    url: '/models/handroanthus.glb',
    scaleFactor: 0.7,
  },
  // 'Alnus acuminata': {
  //   id: 'tree-alnus-acuminata',
  //   // url: '/models/alnus-acuminata.glb',
  //   // url: '/models/arupo_obj.glb',
  //   // url: '/models/arupo_2222_meshy.glb',
  //   // url: '/models/mal.glb',
  //   // url: '/models/prueba1.glb',
  //   // url: '/models/base_basic_shaded.glb',
  //   // url: '/models/Test-001.glb',
  //   // url: '/models/PAsa.glb',
  //   // url: '/models/jueves.glb',
  //   scaleFactor: 4,
  // },
}

export const DEFAULT_MODEL_URL = '/models/tree.glb'
export const DEFAULT_SCALE_FACTOR = 1.0
